import defaultState from './defaultState';
import * as C from '../constants';
import TwentyService from '../../../services/twenty-service';

export default {
  /**
   * @param commit
   */
  resetState({ commit }) {
    commit(C.REVIEW_SETTINGS_STATE_RESET, defaultState());
  },

  /**
   * @param commit
   * @returns {Q.Promise<any>}
   */
  fetchBrandsAndAvailableDomains({ commit }) {
    commit(C.REVIEW_SETTINGS_ITEMS_PENDING);
    return TwentyService.getBrandsAndAvailableDomains()
      .then((res) => {
        commit(C.REVIEW_SETTINGS_ITEMS_SUCCESS, res.data);
      })
      .catch(() => {
        commit(C.REVIEW_SETTINGS_ITEMS_FAILURE);
      });
  },

  /**
   * @param commit
   * @param state
   * @param payload
   * @returns {Q.Promise<any>}
   */
  deleteAvailableDomain({ commit, state }, payload) {
    commit(C.REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_PENDING);
    const domainId = payload.domain.id;
    const availableDomainId = payload.availableDomain.id;
    return TwentyService.deleteAvailableDomain(domainId, availableDomainId)
      .then(() => {
        const brandsWithDomains = state.availableDomains.items;
        const updatedAvailableDomains = brandsWithDomains.map((brand) => {
          const updateDomains = brand.domains.filter(
            element => !(element.domain.id === payload.domain.id &&
              element.availableDomain.id === payload.availableDomain.id
            ));
          return { ...brand, domains: updateDomains };
        });
        commit(C.REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_SUCCESS, updatedAvailableDomains);
      })
      .catch(() => {
        commit(C.REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_FAILURE);
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Q.Promise<any>}
   */
  addAvailableDomain({ commit }, payload) {
    commit(C.REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_PENDING);
    return TwentyService.addAvailableDomain(payload)
      .then(() => {
        commit(C.REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_SUCCESS);
      })
      .catch(() => {
        commit(C.REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_FAILURE);
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/review-settings/actions.js